module.exports = __webpack_public_path__ + "img/user-data-bg.faa95346.png";